import createIcon from '../../createIcon';

/**
 * @component @name Gavel
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOC40NzMyNiA1LjI0MjgzTDUuNjQzMjYgOC4wNjk2M0wxOS43NzczIDIyLjIxOTZMMjIuNjA3MyAxOS4zOTI4TDguNDczMjYgNS4yNDI4M1oiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMi43MDc0IDAuOTk5MjY4TDkuODc5NDMgMy44MjgwN0wxNS41MzcgOS40ODQwN0wxOC4zNjUgNi42NTUyN0wxMi43MDc0IDAuOTk5MjY4WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTQuMjIwOTggOS40ODcxMkwxLjM5MjU4IDEyLjMxNTVMNy4wNDkzOCAxNy45NzIzTDkuODc3NzggMTUuMTQzOUw0LjIyMDk4IDkuNDg3MTJaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTMuMzkzNyAyMS4wMDA4SDEuMzkzNjlWMjMuMDAwOEgxMy4zOTM3VjIxLjAwMDhaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Gavel = createIcon('Gavel', [
  [
    'path',
    {
      d: 'M8.47326 5.24283L5.64326 8.06963L19.7773 22.2196L22.6073 19.3928L8.47326 5.24283Z',
      key: 'x0orf',
    },
  ],
  [
    'path',
    {
      d: 'M12.7074 0.999268L9.87943 3.82807L15.537 9.48407L18.365 6.65527L12.7074 0.999268Z',
      key: '1qambc',
    },
  ],
  [
    'path',
    {
      d: 'M4.22098 9.48712L1.39258 12.3155L7.04938 17.9723L9.87778 15.1439L4.22098 9.48712Z',
      key: '1k6qre',
    },
  ],
  ['path', { d: 'M13.3937 21.0008H1.39369V23.0008H13.3937V21.0008Z', key: '3dm0hp' }],
]);

export default Gavel;
